import { BigBodyGroup } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import {StyleSheet, View } from 'react-native';
import { HomeWorkoutResponsiveLayout } from '../../HomeWorkouts/components/HomeWorkoutResponsiveLayout';
import Theme, { ThemeType } from '../../theme';
import { i18n } from '../../utils';
import {getBodyImage } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import { themeStyleMapper } from '../steps/personaliseWorkoutSteps';
import { SelectionContainer } from './SelectionContainer';
interface IProps {
  bodyGroup: any | null;
  cardioOrResistance: any;
  gender: any;
  orientation: string;
  theme: ThemeType;
  t(key: string): string;
  onPress(bigBodyGroup: BigBodyGroup): Promise<void>;
}

export const FullBody = 'fullBody';
const FullBodyGroup = [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper];

export const mappedBodyGroup = {
  [FullBody]: {
    title: i18n.t('bookings:fullBody'),
    subtitle: i18n.t('bookings:allBodyGroups'),
    image: (gender, cardioOrResistance, width, height, fill1, fill2) =>
      getBodyImage(FullBodyGroup, gender, cardioOrResistance, width, height, fill1, fill2),
  },
  [BigBodyGroup.BackAndArms]: {
    title: i18n.t('bookings:backAndArms'),
    subtitle: i18n.t('bookings:back&ArmsCategoriesAlt'),
    image: (gender, cardioOrResistance, width, height, fill1, fill2) =>
      getBodyImage([BigBodyGroup.BackAndArms], gender, cardioOrResistance, width, height, fill1, fill2),
  },
  [BigBodyGroup.Lower]: {
    title: i18n.t('bookings:bodyGroup', { bodyGroup: BigBodyGroup.Lower }),
    subtitle: i18n.t('bookings:lowerBodyCategoriesAlt'),
    image: (gender, cardioOrResistance, width, height, fill1, fill2) =>
      getBodyImage([BigBodyGroup.Lower], gender, cardioOrResistance, width, height, fill1, fill2),
  },
  [BigBodyGroup.Upper]: {
    title: i18n.t('bookings:bodyGroup', { bodyGroup: BigBodyGroup.Upper }),
    subtitle: i18n.t('bookings:upperBodyCategoriesAlt'),
    image: (gender, cardioOrResistance, width, height, fill1, fill2) =>
      getBodyImage([BigBodyGroup.Upper], gender, cardioOrResistance, width, height, fill1, fill2),
  },
};

export const BodyGroupSelection: FunctionComponent<IProps> = ({
  onPress, bodyGroup, cardioOrResistance, gender, theme = ThemeType.light, orientation}) => {
  const themeStyle = themeStyleMapper[theme];
  const boxHeight = orientation === 'PORTRAIT' ? 100 : 75;
  const boxWidth = orientation === 'PORTRAIT' ? 160 : 145;
  const containerFlex = orientation === 'PORTRAIT' ? null : { flex: 1 };
  const bodyImageHeight = '100%';
  const bodyImageWidth = '100%';
  const bodyImageFill1 = themeStyle.themeColor1Inverse;
  const bodyImageFill2 = themeStyle.bodyImageColor2;

  return (
    <HomeWorkoutResponsiveLayout containerStyle={{flex: 0}}>
    <View style={[styles.svgStyle, containerFlex]}>
        {mappedBodyGroup[bodyGroup].image(gender,cardioOrResistance, bodyImageHeight,
           bodyImageWidth, bodyImageFill1, bodyImageFill2)}
    </View>
     <View style={[styles.wrapedContainer, containerFlex]}>
       <View style={styles.rowContainer}>
     <BodyGroup
        onPress={onPress}
        boxHeight={defaultScale(boxHeight)}
        boxWidth={defaultScale(boxWidth)}
        currentBodyGroup={bodyGroup}
        bodyGroup={FullBody}
        theme={theme}
      />
      <BodyGroup
        onPress={onPress}
        boxHeight={defaultScale(boxHeight)}
        boxWidth={defaultScale(boxWidth)}
        currentBodyGroup={bodyGroup}
        bodyGroup={BigBodyGroup.Lower}
        theme={theme}
      />
      </View>
      <View style={styles.rowContainer}>
      <BodyGroup
        onPress={onPress}
        boxHeight={defaultScale(boxHeight)}
        boxWidth={defaultScale(boxWidth)}
        currentBodyGroup={bodyGroup}
        bodyGroup={BigBodyGroup.BackAndArms}
        theme={theme}
      />
        <BodyGroup
        onPress={onPress}
        currentBodyGroup={bodyGroup}
        boxHeight={defaultScale(boxHeight)}
        boxWidth={defaultScale(boxWidth)}
        bodyGroup={BigBodyGroup.Upper}
        theme={theme}
      />
      </View>
    </View>
   </HomeWorkoutResponsiveLayout> 
  );
};

const BodyGroup = ({ currentBodyGroup, bodyGroup,
  onPress, boxHeight, boxWidth, theme}) => {
  const isSelected = currentBodyGroup === bodyGroup;
  const prepBodyGroup = (bGroup) => bGroup === FullBody ? onPress(FullBodyGroup) : onPress([bGroup]);
  const themeStyle = themeStyleMapper[theme];
  return (
    <View>
      <SelectionContainer
        width={defaultScale(boxWidth)}
        height={defaultScale(boxHeight)}
        title={mappedBodyGroup[bodyGroup].title}
        titleStyle={[styles.title, { color: isSelected ? themeStyle.themeColor1Inverse : themeStyle.themeColor1 }]}
        margin={5}
        isSelected={isSelected}
        subTitle={mappedBodyGroup[bodyGroup].subtitle}
        subTitleStyle={[styles.subtitle, { color: isSelected ? themeStyle.themeColor1Inverse : themeStyle.themeColor1 }]}
          // {color: isSelected ?
          // theme === ThemeType.light ? Theme.GREY_MEDIUM_LIGHT : Theme.GREY_DARK_MEDIUM : themeStyle.themeColor2}]}
        onPress={() => prepBodyGroup(bodyGroup)}
        theme={theme}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapedContainer: {
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
  },
  rowContainer: {
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%'
  },
  title: {
    ...Theme.textStyle.bodyCopyMed,
    paddingTop: defaultScale(8),
    textAlign: 'center',
  },
  subtitle: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
  },
  svgStyle: {
    height: defaultScale(200),
    alignItems: 'center',
    justifyContent: 'center',
  },
});
